import request from '@/utils/request'

export function epms9060List(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9060/epms9060List`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getPorList1(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9060/getPorList1`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

//epms9060Xls
export function epms9060Xls(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9060/epms9060Xls`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    }).then(res => {
        console.log('epms6600Xls RES', res)

        const base64String = res.body

        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

        const binaryString = window.atob(base64)

        const binaryLen = binaryString.length
        let bytes = new Uint8Array(binaryLen)

        for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
        }

        const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        const blobURL = URL.createObjectURL(blob)

        const link = document.createElement('a');
        link.href = blobURL;
        link.download = `Delivery Status List.xls`;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    })
}